import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';

import * as api from '../../services/api/auth';

class AppointmentCancel extends Component {
  state = {
    hasError: false,
    errorText: '',
    cancelToken: '',
  };

  componentDidMount() {
    const { cancelToken } = this.props.match.params;
    if (!cancelToken) {
      window.location.href = process.env.REACT_APP_HOMEPAGE_URL;
    }

    this.setState({ cancelToken });
  }

  onSubmit = async () => {
    const { history } = this.props;

    try {
      const { cancelToken } = this.state;
      await api.cancelAppointment({ cancelToken });
      history.push('/appointments/cancel/confirmation');
    } catch (err) {
      if (
        err.response &&
        err.response.data &&
        err.response.data.alreadyCancelled
      ) {
        this.setState({
          hasError: true,
          errorText:
            'Your appointment is already cancelled, no need to try again.',
        });
      } else {
        this.setState({
          hasError: true,
          errorText: 'Appointment cancellation failed, please try again.',
        });
      }
    }
  };

  render() {
    const { hasError, errorText } = this.state;
    const { classes } = this.props;

    return (
      <Grid
        container
        direction="column"
        alignItems="center"
        justifyContent="center"
        classes={{ container: classes.container }}
      >
        {hasError && (
          <Grid item xs={12} md={6} classes={{ item: classes.error }}>
            <span>{errorText}</span>
          </Grid>
        )}

        <Grid item xs={12} md={6} className="paddingZero">
          <Grid container classes={{ container: classes.containerForm }}>
            <Grid item xs={12}>
              <h2 className={classes.headerText}>
                Are you sure you want to cancel your Appointment?
              </h2>
            </Grid>

            <Grid item xs={12}>
              <p className={classes.subtext}>
                Click the button below to cancel. If we successfully cancel your
                appointment you will receive an email and will be redirected to
                a confirmation page.
              </p>
            </Grid>

            <Grid item xs={12}>
              <Button
                onClick={this.onSubmit}
                color="primary"
                variant="contained"
                className={classes.submitButton}
              >
                Cancel Appointment
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  }
}

const styles = () => ({
  container: {
    width: '100%',
    padding: '4em',
  },
  containerForm: {
    padding: '1rem',
    marginTop: '2em',
  },
  error: {
    width: '100%',
    backgroundColor: '#FFF6BF',
    color: 'grey',
    padding: '1rem',
    textAlign: 'center',
    border: '1px solid rgba(183,210,229,0.8)',
    borderRadius: '8px',
    boxShadow: 'inset 0 -1px 0 0 #7E95A7, 0 1px 4px 0 rgba(44,64,90,0.21)',
  },
  headerText: {
    color: '#1C1C1C',
    fontSize: '40px',
    fontWeight: '300',
    lineHeight: '47px',
    paddingBottom: '25px',
  },
  subtext: {
    color: '#1C1C1C',
    fontSize: '16px',
    lineHeight: '24px',
    paddingBottom: '25px',
  },
});

export default withStyles(styles)(AppointmentCancel);
